"use client";

import { useTheme } from "next-themes";
import { useEffect, useState } from "react";
import { Sun, Moon } from "lucide-react";
import { cn } from "@/lib/utils";

export function FooterThemeToggle({ className }: { className?: string }) {
  const { resolvedTheme, setTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => setMounted(true), []);

  const isDark = mounted && resolvedTheme === "dark";

  const handleToggle = () => {
    if (!mounted) return;
    setTheme(resolvedTheme === "dark" ? "light" : "dark");
  };

  return (
    <button
      type="button"
      onClick={handleToggle}
      aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
      title={isDark ? "Switch to light mode" : "Switch to dark mode"}
      className={cn(
        "inline-flex items-center gap-1 rounded-full border border-border/60 bg-background/80 p-1 shadow-sm backdrop-blur-md",
        className,
      )}
    >
      <span
        className={cn(
          "inline-flex h-7 w-7 items-center justify-center rounded-full transition-colors",
          !isDark
            ? "bg-foreground/10 text-foreground"
            : "text-foreground/55 hover:text-foreground",
        )}
      >
        <Sun className="h-3.5 w-3.5" strokeWidth={2.2} />
      </span>
      <span
        className={cn(
          "inline-flex h-7 w-7 items-center justify-center rounded-full transition-colors",
          isDark
            ? "bg-foreground/10 text-foreground"
            : "text-foreground/55 hover:text-foreground",
        )}
      >
        <Moon className="h-3.5 w-3.5" strokeWidth={2.2} />
      </span>
    </button>
  );
}
